import isVisibleEvent from "@/helpers/visibility/isVisibleEvent";
import { minutesToTime } from "@/stories/utils/dates";
import type { VisibleEvent, VisibilityOptions } from "@/types";

export default (data: VisibleEvent): VisibilityOptions => {
  const options: Partial<VisibilityOptions> = {};

  if (data.showFrom === null) {
    options.visibilityType = "now";
  } else if (data.showFrom === 0) {
    options.visibilityType = "onStartTime";
  } else {
    options.visibilityType = "beforeXMinutes";
    const { days, hours, minutes } = minutesToTime(data.showFrom || 0);
    options.visibleFromDays = days;
    options.visibleFromHours = hours;
    options.visibleFromMinutes = minutes;
  }

  options.isVisible = isVisibleEvent(data, options as VisibilityOptions);

  return options as VisibilityOptions;
};
